import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { RotateButtons } from '@vlabs/monokit/shared/ui/rotate-buttons';

import st from './ControlPanel.module.sass';
import { Toast } from './Toast';

export function DefaultControlPanel({
  mediaSize = undefined,
  degree = undefined,
  onChangeRotationDeg = undefined,
}) {
  const { t } = useTranslation();

  return (
    <div className={cn(st.UpperRow, st.UpperRow_default)}>
      <Toast
        mediaSize={mediaSize}
        message={t('roi.modal.panel.info_text.zone', { context: 'select' })}
      />

      <RotateButtons
        degree={degree}
        onChange={onChangeRotationDeg}
      />
    </div>
  );
}
